<template>
	<label :class="computedLabel"
		>{{ label }}
		<input type="checkbox" :value="internalValue" :disabled="isDisabled" @change="emitvalue" />
		<span :class="computedCheckmark"></span>
	</label>
</template>
<script>
export default {
	name: 'Checkbox',
	props: {
		label: {
			type: String,
			required: true,
		},
		checked: {
			type: Boolean,
			required: true,
		},
		internalValue: {
			type: Number,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		computedLabel() {
			return {
				'checkbox-field': true,
				'checkbox-field--disabled': this.isDisabled,
			};
		},
		computedCheckmark() {
			return {
				checkmark: !this.isDisabled,
				'checkmark--checked': this.checked,
				'checkmark--disabled': this.isDisabled,
			};
		},
	},
	methods: {
		emitvalue() {
			this.$emit('change', this.internalValue);
		},
	},
};
</script>
<style lang="scss" scoped>
@import './Checkbox.scss';
</style>
